module.exports = __webpack_public_path__ + "img/fob_symbol.ac78175c.svg";